<template>
  <div class="navbar">
    <div class="nav-menu">
      <span v-for="(item, index) in menus" :key="index" :class="{ active: activeIndex === index }" @click="setActive(index)">{{ item.title }}</span>
    </div>
    <el-link style="color: #ddeeff; border-bottom: 1px solid #ddeeff" @click="clickLogout">
      {{ i18n.ctrl.Logout }}
    </el-link>
  </div>
</template>

<script>
import { mapActions } from "vuex"
export default {
  data() {
    return {
      menus: [
        { title: "Home", path: "/home" },
        { title: "Admin", path: "/admin" },
        { title: "My", path: "/my" }
        // { title: "Dashboard", path: "/dashboard" },
      ],
      activeIndex: 1
    }
  },
  computed: {
    i18n() {
      return this.$t("index")
    }
  },
  mounted() {
    const path = this.$route.path
    const index = this.menus.findIndex(item => item.path === path) || 0
    if (index !== -1) this.setActive(index)
  },
  methods: {
    ...mapActions("auth", ["logout"]),
    setActive(index) {
      const item = { ...this.menus[index] }
      this.activeIndex = index
      this.$router.push(item.path)
    },

    clickLogout() {
      this.logout()
    }
  }
}
</script>

<style scoped>
.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 4px;
}

.nav-menu span {
  color: var(--blue-dark);
  padding: 15px 20px;
  font-size: 14px;
  text-decoration: none;
  text-align: center;
}

.nav-menu span:hover {
  color: #eee;
  border-bottom: 4px solid rgba(21, 44, 115, 0.5);
}

.nav-menu span.active {
  color: #fff;
  border-bottom: 4px solid var(--blue-dark);
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
  transform: scale(1.02);
}
</style>



// WEBPACK FOOTER //
// src/layout/desktop/NavBar.vue